import { render, staticRenderFns } from "./voteStatusTdComp.vue?vue&type=template&id=a9064afe&scoped=true"
import script from "./voteStatusTdComp.vue?vue&type=script&lang=js"
export * from "./voteStatusTdComp.vue?vue&type=script&lang=js"
import style0 from "./voteStatusTdComp.vue?vue&type=style&index=0&id=a9064afe&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9064afe",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/actions-runner/_work/treasurenet-tnservices-servicesplatform-fe/treasurenet-tnservices-servicesplatform-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a9064afe')) {
      api.createRecord('a9064afe', component.options)
    } else {
      api.reload('a9064afe', component.options)
    }
    module.hot.accept("./voteStatusTdComp.vue?vue&type=template&id=a9064afe&scoped=true", function () {
      api.rerender('a9064afe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/governance/components/voteStatusTdComp.vue"
export default component.exports